import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import useDiscountMessage, {
  type UseDiscountMessageProps,
} from '@/app/components/PageLayout/_hooks/useDiscountMessage';

const DiscountMessage = () => {
  const { isAccessory } = useWizardStateContext();
  const { displayMessage } = useDiscountMessage({
    gen3WizardConsumer: true,
    isAccessory,
  } as UseDiscountMessageProps);

  return (
    <div
      data-cy="banner-message"
      className={cx(
        'absolute top-0 right-0 left-0 z-20 w-screen transform bg-white text-center transition duration-300 ease-in-out motion-reduce:transition-none',
        {
          '-translate-y-full opacity-0': !displayMessage,
          'translate-y-0 opacity-100': displayMessage,
        },
      )}
    >
      {displayMessage && (
        <div className="mx-auto max-w-7xl px-1 py-[1.0625rem]">
          <Typography
            variant="body-small"
            weight="normal"
            align="center"
            height="none"
          >
            <span data-cy="discount-message-text">{displayMessage}</span>
          </Typography>
        </div>
      )}
    </div>
  );
};

export default DiscountMessage;
